export default __webpack_public_path__ + "static/poster-d66ef329cf055175e5ecfc63a07295ae.png";